import { Container } from 'react-bootstrap';
import Image from 'react-bootstrap/Image'
import ForbiddenImage from '../../Assets/img/Forbidden.png'

function NoMatch(){
    return (
        <Container>
            <Image fluid={true} src={ForbiddenImage} alt="Access denied"/>
        </Container>
    );
};

export default NoMatch;